// src/hooks/Purchases/useCheckSellPriceActivation.ts
import { useAppDispatch } from '@store/hooks';
import { checkActivateSellPriceByOperatingnUnitId } from '@store/purchases/PurchaseOrder/purchaseOrderSlice';
import { useCallback, useEffect, useState } from 'react';

type SellPriceActivationResult = {
  priceListId: string;
  isActive: boolean;
};

type UseCheckSellPriceActivationResult = {
  data: SellPriceActivationResult | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
};

export default function useCheckSellPriceActivation(organizationId?: string | null): UseCheckSellPriceActivationResult {
  const dispatch = useAppDispatch();
  const [data, setData] = useState<SellPriceActivationResult | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setError(null);
    // لو ما فيه OU/Organization ما نسوي شيء
    if (!organizationId) {
      setData(null);
      return;
    }

    setIsLoading(true);
    try {
      const result = await dispatch(checkActivateSellPriceByOperatingnUnitId(organizationId)).unwrap();
      if (result.succeeded === true) {
        setData(result.data);
      } else {
        setData(null);
      }
    } catch (e: any) {
      setData(null);
      setError(e?.response?.data?.message ?? e?.message ?? 'Failed to load sell price activation');
    } finally {
      setIsLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchData
  };
}
